module.exports = __webpack_public_path__ + "static/media/watercolor-1.457141ba.png";